import React from 'react';

import CombinedMenuItem from '../Components/CombinedMenuItem/CombinedMenuItem';

const Divider = () => {
  return <CombinedMenuItem type="divider" />;
};

export default Divider;
